import { render, staticRenderFns } from "./SubjectAreaForm.vue?vue&type=template&id=388d611a&"
import script from "./SubjectAreaForm.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports